var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 29.7C23.7901 29.7 29.7 23.7902 29.7 16.5C29.7 9.20984 23.7901 3.3 16.5 3.3C9.20983 3.3 3.29999 9.20984 3.29999 16.5C3.29999 23.7902 9.20983 29.7 16.5 29.7Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 25.85V23.65C20.9 23.3464 20.6536 23.1 20.35 23.1H18.15V13.2C18.15 12.8964 17.9036 12.65 17.6 12.65H12.65C12.3464 12.65 12.1 12.8964 12.1 13.2V15.4C12.1 15.7036 12.3464 15.95 12.65 15.95H14.85V23.1H12.65C12.3464 23.1 12.1 23.3464 12.1 23.65V25.85",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 10.45C17.165 10.45 18.15 9.46503 18.15 8.25C18.15 7.03497 17.165 6.05 15.95 6.05C14.735 6.05 13.75 7.03497 13.75 8.25C13.75 9.46503 14.735 10.45 15.95 10.45Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 4.95H26.95V6.05H28.05V4.95Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 2.75H24.2V3.85H25.3V2.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 7.7H29.15V8.8H30.25V7.7Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05001 26.95H4.95001V28.05H6.05001V26.95Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80001 29.15H7.70001V30.25H8.80001V29.15Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85 24.2H2.75V25.3H3.85V24.2Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1857 23.5681C30.6895 22.5946 31.0926 21.56 31.3808 20.4793",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.471 31.383C24.194 30.3925 27.3625 28.0418 29.4124 24.8958",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81435 9.43195C2.31055 10.4054 1.9074 11.44 1.6192 12.5207",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.529 1.617C8.80605 2.60755 5.6375 4.95825 3.58765 8.10425",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.04e4b9f4.svg";
export { ForwardRef as ReactComponent };